'use client';

import React from 'react';
import ErrorStateScreen from '@/components/ErrorStateScreen';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html data-component-id="src/app/global-error.tsx:14:4" data-component-path="src/app/global-error.tsx" data-component-line="14" data-component-end-line="23" data-component-file="global-error.tsx" data-component-name="html" data-component-content="%7B%22elementName%22%3A%22html%22%7D" lang="en">
      <body data-component-id="src/app/global-error.tsx:15:6" data-component-path="src/app/global-error.tsx" data-component-line="15" data-component-end-line="22" data-component-file="global-error.tsx" data-component-name="body" data-component-content="%7B%22elementName%22%3A%22body%22%7D">
        <ErrorStateScreen data-component-id="src/app/global-error.tsx:16:8" data-component-path="src/app/global-error.tsx" data-component-line="16" data-component-end-line="21" data-component-file="global-error.tsx" data-component-name="ErrorStateScreen" data-component-content="%7B%22elementName%22%3A%22ErrorStateScreen%22%7D"
          error={error}
          reset={reset}
          title="We’re already on this"
          description="Something went wrong at the application level. We have logged the incident details and our team is actively working to restore the experience."
        />
      </body>
    </html>
  );
}
